"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyState = void 0;
var LobbyState;
(function (LobbyState) {
    LobbyState["WaitingPlayers"] = "waiting_players";
    LobbyState["WaitingCountdown"] = "waiting_countdown";
    LobbyState["WaitingClose"] = "waiting_close";
    LobbyState["Launching"] = "launching";
})(LobbyState || (exports.LobbyState = LobbyState = {}));
